export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Olla Home Solution',
    address: '',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
